class QualityAssurance {
    private storage = localStorage;

    private getItem(name: string) {
        if(this.storage.getItem('qa') === 'true') {
            const result = this.storage.getItem(`qa-${name}`);

            if(result) {
                return result;
            }
        }
    }

    private getItemNumber(name: string) {
        const value = this.getItem(name);

        if(value) {
            const result = parseInt(value, 10);

            if(!Number.isNaN(result)) {
                return result;
            }
        }
    }

    public getSupplierOldID() {
        return this.getItemNumber('supplier-old-id');
    }

    public getSupplierID() {
        return this.getItem('supplier-id');
    }

    public getQuiz() {
        return this.getItem('quiz-disabled') === 'true';
    }
}

export const qa = new QualityAssurance();
